// prop-types is a library for typechecking of props
import propTypes from 'prop-types';
// @mui material components
import Grid from '@mui/material/Grid';

// Material Dashboard 2 React components
// Material Dashboard 2 React example components
// Data to delete
// import currencysTableData from "layouts/tables/data/currencysTableData";
import {
  Box,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography
} from '@mui/material';

import { useEffect, useState } from 'react';
// eslint-disable-next-line
import { useDispatch, useSelector } from 'react-redux';

import { Spinner } from '../../../components/Spinner';
import ApiService from '../../../helpers/apiHelper';
import { dateFormattingByDateDot } from '../../../helpers/date-helpers';

function createTableData(
  id,
  creationDate,
  name,
  surname,
  nickname,
  lastServiceName,
  numberOfService,
  serviceId,
  templateData
) {
  return {
    id,
    creationDate,
    name,
    surname,
    nickname,
    lastServiceName,
    numberOfService,
    serviceId,
    templateData
  };
}

function Row({ row, actions }) {
  // const userData = useSelector((state) => state.global.userData);
  // const [anchorEl, setAnchorEl] = useState(null);
  // const open = Boolean(anchorEl);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  // const badgeContent = () => {
  //   if (row.status === "premium") {
  //     return "Преміум";
  //   } else if (row.status === "base") {
  //     return "Базовий";
  //   }
  // };
  // const badgeColor = () => {
  //   if (row.status === "premium") {
  //     return "warning";
  //   } else if (row.status === "base") {
  //     return "success";
  //   }
  // };
  // eslint-disable-next-line
  // const CustomWidthTooltip = styled(({ className, ...props }) => (
  //   <Tooltip {...props} classes={{ popper: className }} />
  // ))({
  //   [`& .${tooltipClasses.tooltip}`]: {
  //     width: '300px',
  //     maxWidth: '500px'
  //   }
  // });
  // const CustomDescTooltip = styled(({ className, ...props }) => (
  //   <Tooltip {...props} classes={{ popper: className }} />
  // ))({
  //   [`& .${tooltipClasses.tooltip}`]: {
  //     width: "max-content",
  //     maxWidth: "600px",
  //   },
  // });

  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell align="left">
          <Typography
            sx={({ typography: { size, fontWeightRegular } }) => ({
              fontSize: { xs: '12px', sm: '14px', md: '16px' },
              fontWeight: fontWeightRegular,
              textTransform: 'capitalize',
              fontFamily: 'FixelText-Regular !important'
            })}
          >
            {row?.name && row?.surname ? (
              <Typography
                sx={({ typography: { size, fontWeightRegular } }) => ({
                  fontSize: { xs: '12px', sm: '14px', md: '16px' },
                  fontWeight: fontWeightRegular,
                  textTransform: 'capitalize',
                  fontFamily: 'FixelText-Regular !important',
                  display: { xs: 'none', sm: 'block' }
                })}
              >
                {`${row.surname} ${row.name}`}
              </Typography>
            ) : null}

            <Typography
              sx={({ typography: { size, fontWeightLight } }) => ({
                fontSize: { xs: '12px', sm: '14px', md: '16px' },
                fontWeight: fontWeightLight,
                textTransform: 'capitalize',
                fontFamily: 'FixelText-Regular !important',
                color: '#60A5DF'
              })}
            >
              {`@${row.nickname}`}
            </Typography>
          </Typography>
        </TableCell>
        <TableCell
          align="center"
          sx={({ typography: { size, fontWeightLight } }) => ({
            fontSize: { xs: '12px', sm: '14px', md: '16px' },
            fontWeight: fontWeightLight,
            textTransform: 'uppercase',
            fontFamily: 'FixelText-Regular !important'
            // width: cell.width,
          })}
        >
          <Typography
            onClick={() => {
              window.open(`${window.location.origin}/ua/service/${row.serviceId}`);
              window.scrollTo({ top: 0 });
            }}
            sx={({ typography: { size, fontWeightLight } }) => ({
              fontSize: { xs: '12px', sm: '14px', md: '16px' },
              fontWeight: fontWeightLight,
              textTransform: 'capitalize',
              color: '#60A5DF',
              fontFamily: 'FixelText-Regular !important',
              textAlign: 'left',
              cursor: 'pointer'
            })}
          >
            {/* {dateTimeFormattingByString(row.creationDate)} */}
            {row.lastServiceName}
          </Typography>
        </TableCell>
        <TableCell
          align="center"
          sx={({ typography: { size, fontWeightBold } }) => ({
            fontSize: { xs: '12px', sm: '14px', md: '16px' },
            fontWeight: fontWeightBold,
            textTransform: 'uppercase',
            fontFamily: 'FixelText-Regular !important'
            // width: cell.width,
          })}
        >
          <Typography
            sx={({ typography: { size, fontWeightLight } }) => ({
              fontSize: { xs: '12px', sm: '14px', md: '16px' },
              fontWeight: fontWeightLight,
              textTransform: 'capitalize',
              fontFamily: 'FixelText-Regular !important'
            })}
          >
            {/* {dateTimeFormattingByString(row.creationDate)} */}
            {row.numberOfService}
          </Typography>
        </TableCell>
        <TableCell
          align="center"
          sx={({ typography: { size, fontWeightMedium } }) => ({
            fontSize: { xs: '12px', sm: '14px', md: '16px' },
            fontWeight: 500,
            textTransform: 'uppercase',
            fontFamily: 'FixelText-Regular !important'
            // width: cell.width,
          })}
        >
          <Typography
            sx={({ typography: { size, fontWeightMedium } }) => ({
              fontSize: { xs: '12px', sm: '14px', md: '16px' },
              fontWeight: 500,
              textTransform: 'capitalize',
              fontFamily: 'FixelText-Regular !important'
            })}
          >
            {dateFormattingByDateDot(new Date(row.creationDate))}
          </Typography>
        </TableCell>

        {/* <TableCell align="center"> */}
        {/* <Button
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <MoreVertIcon />
          </Button> */}
        {/* <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem
              onClick={() => {
                editRow(row, "block");
                handleClose();
              }}
            >
              <BlockIcon
                sx={{ fontSize: "16px !important", cursor: "pointer", mr: 1 }}
              />
              {row?.templateData?.isBlockedPost
                ? "Розблокувати"
                : "Заблокувати"}
            </MenuItem>
            {userData && userData?.role && userData?.role !== "ADMIN" && (
              <MenuItem
                onClick={() => {
                  editRow(row, "edit");
                  handleClose();
                }}
              >
                <EditIcon
                  sx={{
                    fontSize: "16px !important",
                    cursor: "pointer",
                    mr: 1,
                  }}
                />
                <Typography>Змінити</Typography>
              </MenuItem>
            )}

            <MenuItem
              onClick={() => {
                editRow(row, "delete");
                handleClose();
              }}
            >
              <DeleteOutlineIcon
                sx={{ fontSize: "16px !important", cursor: "pointer", mr: 1 }}
              />
              Видалити
            </MenuItem>
          </Menu> */}

        {/* <Typography
            sx={({ typography: { size, fontWeightBold } }) => ({
              fontSize: '14px',
              fontWeight: fontWeightBold,
              textTransform: "uppercase",
            })}
          > */}
        {/* </TableCell> */}
      </TableRow>
    </>
  );
}

function BuyersTable() {
  const userData = useSelector((state) => state.global.userData);
  // eslint-disable-next-line
  // const [selectedRow, setSelectedRow] = useState(null);
  const [pagesCount, setPagesCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line

  // eslint-disable-next-line

  const [sortDirection, setSortDirection] = useState('Desc');
  const [sortField, setSortField] = useState('creationDate');
  // eslint-disable-next-line
  const isOpenSearchBar = useSelector((state) => state.global.isOpenSearchBar);
  // eslint-disable-next-line
  const dispatch = useDispatch();

  const apiGetBuyers = new ApiService('posts/order/get-buyers');
  // const apiGetBuyers = new ApiService('/order/get-buyers');

  const tableCells = [
    { header: "Ім'я користувача", align: 'left', width: '160px' },
    { header: 'Назва товару', align: 'left', width: '160px' },
    {
      header: 'Замовлення',
      align: 'center',
      width: '145px',
      label: 'numberOfService',
      padding: '30px'
    },
    { header: 'Дата', align: 'center', label: 'creationDate', width: '105px', padding: '35px' }
    // { header: "Дії", align: "center", width: "5%" },
  ];

  const [rows, setRows] = useState([]);

  const handleGetBuyers = () => {
    setIsLoading(true);
    apiGetBuyers
      .getAll({
        from: offset,
        size: 10,
        sortedFiled: sortField,
        sortOrder: sortDirection
      })
      .then((res) => {
        const rows = res.result.map((row) => {
          return createTableData(
            row.id,
            row.creationDate,
            row.name,
            row.surname,
            row.nickname,
            row.lastServiceName,
            row.numberOfService,
            row.serviceId,
            row
          );
        });
        setRows(rows);
        setPagesCount(
          Number.isInteger(res.count / 10) ? res.count / 10 : Math.floor(+(res.count / 10)) + 1
        );
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };
  // const searchFunction = (searchValue) => {
  //   setIsLoading(true);
  //   if (searchValue && searchValue.length !== 0) {
  //     apiGetHistory
  //       .getAll({
  //         startWith: 0,
  //         count: 10,
  //         searchString: searchValue ? searchValue : '',
  //         filterWithAdminActionType: isFilter,
  //         adminActionType: filterBy?.enum && isFilter ? filterBy?.enum : ''
  //       })
  //       .then((res) => {
  //         const rows = res.result.map((row) => {
  //           return createTableData(
  //             row.id,
  //             row.description,
  //             row.creationTimeOfAction,
  //             row.valueLikes,
  //             row.numberComments,
  //             row
  //           );
  //         });
  //         setRows(rows);
  //         setPagesCount(
  //           Number.isInteger(res.count / 10) ? res.count / 10 : Math.floor(+(res.count / 10)) + 1
  //         );
  //         setIsLoading(false);
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //         setIsLoading(false);
  //       });
  //   } else {
  //     handleGetBuyers();
  //   }
  // };

  useEffect(() => {
    if (userData && userData?.id) {
      handleGetBuyers();
    }
    // dispatch(setIsOpenSearchBar(true));
    // eslint-disable-next-line
  }, [userData, offset, sortDirection, sortField]);
  return (
    <Grid container spacing={6} sx={{ mb: '20px' }}>
      <Grid item xs={12}>
        <Box pt={2}>
          {/* <DataTable
                  // canSearch
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                /> */}
          {!isLoading ? (
            <>
              {' '}
              <TableContainer
                component={Paper}
                sx={{
                  borderRadius: '8px 8px 0px 0px !important',
                  border: '2px solid #F0F0F0',
                  borderBottom: 'none',
                  mt: 1.5
                }}
              >
                <Table>
                  <TableHead
                    sx={{
                      borderRadius: '0px !important',
                      display: 'table-header-group',
                      backgroundColor: '#E2F2FF',
                      tableLayout: 'fixed',
                      width: '100%'
                    }}
                  >
                    <TableRow>
                      {tableCells.map((cell, index) => (
                        <TableCell
                          key={cell.header + cell + index}
                          align={cell.align}
                          sx={{
                            width: cell?.width,
                            maxWidth: cell?.width, // чтобы не превышало
                            minWidth: cell?.width,
                            borderBottom: 'none',
                            fontFamily: 'FixelText-Medium !important',
                            fontSize: { xs: '12px', sm: '14px', md: '16px' },
                            fontWeight: 500,
                            paddingLeft: cell?.padding && cell?.padding
                          }}
                        >
                          {cell.header}
                          {cell?.label === 'creationDate' || cell?.label === 'numberOfService' ? (
                            <TableSortLabel
                              sx={{ cursor: 'pointer' }}
                              active={sortField === cell?.label}
                              direction={sortDirection === 'Asc' ? 'asc' : 'desc'}
                              onClick={() => {
                                if (sortDirection === 'Asc') {
                                  setSortDirection('Desc');
                                } else {
                                  setSortDirection('Asc');
                                }
                                setSortField(cell?.label);
                              }}
                            />
                          ) : null}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row) => (
                      <Row key={row.id + row.tikker} row={row} refreshData={handleGetBuyers} />
                    ))}
                  </TableBody>
                </Table>
                {rows.length === 0 && (
                  <Typography sx={{ m: '150px auto', textAlign: 'center' }}>
                    Покупців не знайдено
                  </Typography>
                )}
              </TableContainer>
              <Pagination
                sx={{
                  display: 'flex',
                  justifyContent: 'end',
                  m: 0,
                  backgroundColor: 'white',
                  border: '2px solid #F0F0F0',
                  borderRadius: '0px 0px 8px 8px',
                  padding: '5px'
                }}
                defaultPage={1}
                siblingCount={0}
                count={pagesCount}
                shape="rounded"
                page={offset + 1}
                onChange={(event, value) => setOffset(value - 1)}
              />
            </>
          ) : (
            <div style={{ marginTop: '10%', marginBottom: '10%' }}>
              <Spinner type="small" />
            </div>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}

Row.propTypes = {
  row: propTypes.object
};
export default BuyersTable;
